document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const drawer = document.querySelector('.mobile-drawer');
  const close = document.querySelector('.drawer-close');
  const setOpen = (open) => {
    if (!toggle || !drawer) return;
    toggle.setAttribute('aria-expanded', String(open));
    drawer.hidden = !open;
    document.body.classList.toggle('menu-open', open);
  };
  toggle?.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
  close?.addEventListener('click', () => setOpen(false));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setOpen(false); });
});

// Tenner Tuesday storefront display. Uses Europe/London so BST/GMT changes are handled automatically.
document.addEventListener('DOMContentLoaded', () => {
  let isTuesday = false;
  try {
    const weekday = new Intl.DateTimeFormat('en-GB', { weekday: 'short', timeZone: 'Europe/London' }).format(new Date());
    isTuesday = weekday === 'Tue';
  } catch (e) {
    isTuesday = new Date().getDay() === 2;
  }

  document.querySelectorAll('[data-tenner-tuesday]').forEach((el) => {
    el.hidden = !isTuesday;
  });

  if (!isTuesday) return;
  const deal = document.querySelector('.product-info [data-tenner-tuesday][data-tt-qty]');
  const qty = document.querySelector('[data-product-quantity]');
  const addDeal = document.querySelector('[data-tt-add-deal]');
  if (deal && qty && addDeal) {
    const dealQty = parseInt(deal.dataset.ttQty || '0', 10);
    if (dealQty > 0) {
      addDeal.hidden = false;
      addDeal.textContent = `Add ${dealQty} for £10 deal`;
      addDeal.addEventListener('click', () => {
        qty.value = String(dealQty);
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }
});
